import React from "react"
import { useSelector } from "react-redux"

import Table from "../../shared/table"
import Button from "../../shared/button"
import ROUTES from "../../services/routes"
import { IRedux } from "../../services/types"
import { IUserCustom } from "../../interfaces/user.custom"
import useHistoryCustom from "../../hooks/useHistoryCustom"
import { downloadBadge } from "../badge/badge.download"
import EmailApi from "../../services/api/Email.api"

const UsersTable = ({ users }: { users: IUserCustom[] }) => {
  const history = useHistoryCustom()
  const settings = useSelector((state: IRedux) => state.settings?.extended)

  return (
    <Table
      columns={[
        {
          header: "Prénom",
          accessor: ({ firstName }: IUserCustom) => firstName
        },
        {
          header: "Nom",
          accessor: ({ lastName }: IUserCustom) => lastName
        },
        {
          header: "Email",
          accessor: ({ email }: IUserCustom) => email
        },
        {
          header: "Société",
          accessor: ({ name }: IUserCustom) => name
        },
        {
          header: "Envoyer le badge",
          accessor: ({ userId, email, isExhibitor }: IUserCustom) =>
            email && (
              <Button
                onClick={() =>
                  email && settings && settings.badgeId
                    ? new EmailApi().sendFromActionId(
                        isExhibitor ? 6 : 1,
                        [userId],
                        { badgeId: settings.badgeId }
                      )
                    : null
                }
                disabled={!settings?.badgeId}
                label="Envoyer le badge"
                labelSuccess="Badge envoyé"
              />
            )
        },
        settings &&
          !settings.hideDownloadBadge && {
            header: "Télécharger le badge",
            accessor: ({ userId }: IUserCustom) => (
              <Button
                onClick={() =>
                  settings.badgeId && downloadBadge(userId, settings.badgeId)
                }
                label="Télécharger le badge"
                labelSuccess="Badge téléchargé"
                disabled={!settings?.badgeId}
              />
            )
          },
        settings &&
          !settings.hideUpdateUser && {
            header: "Modifier",
            accessor: ({ userId }: IUserCustom) => (
              <button
                type="button"
                className="button is-primary"
                style={{ width: "100%" }}
                onClick={() =>
                  history.push(`${ROUTES.EVENTS_INSCRIPTION}`, { userId })
                }
              >
                Modifier
              </button>
            )
          }
      ]}
      data={users}
    />
  )
}

export default UsersTable
